import { standardMeasurements } from './Base';

export const borderRadii = {
  ...standardMeasurements,
  input: standardMeasurements[2],
  rounded: `${10000000}px`,
};

export type BorderRadius = keyof typeof borderRadii;
